import React, { useEffect, useState } from "react";
import { Input } from "antd";

import styles from "../pages/Login.module.css";

function PhoneInput({
    disabled,
    onChange,
    value,
}: {
    disabled?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    value?: string;
}) {
    const [inputValue, setInputValue] = useState(value || "");
    const [disableInput, setDisableInput] = useState(disabled || false);

     useEffect(() => {
        value && setInputValue(value);
    }, [value]);

    useEffect(() => {
        disabled !== undefined && setDisableInput(disabled);
    }, [disabled]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const tempString = e.target.value;
        e.target.value = tempString.replace(/\D/g, "");

        const regex = /^[0-9\b]{0,13}$/;
        if (regex.test(e.target.value)) {
            setInputValue(e.target.value);

            if (onChange !== undefined) onChange(e);
        }
    };

    return (
        <Input
            className={styles.loginInput}
            type="text"
            disabled={disableInput}
            onChange={handleChange}
            value={inputValue}
            placeholder="휴대전화 번호"
        />
    );
}

export default PhoneInput;
